
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from 'react-markdown';

import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { RootState } from '@share/utils';
import { faqMarkDownContent, MarkDownEnum } from '@common-types';

import './style.scss';
import { useMemo } from 'react';

interface IProps {
  messageId: MarkDownEnum;
}

export function Markdown(props: IProps) {
  const { messageId } = props;

  const intl = useIntl();
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account } = loginStore;
  const { items } = menuStore;

  const phone = items?.phone;
  const isMLM = items?.isMLM;
  const orgId = items?.organizationId;
  const organizationName = items?.organizationName;

  const privacyPolicyExclusiveOrgidList = account?.privacyPolicyExclusiveOrgidList;
  const mainBackgroundColor = account?.mainBackgroundColor;

  const isExclude = useMemo(() => privacyPolicyExclusiveOrgidList?.includes(orgId?.toString()), [orgId, privacyPolicyExclusiveOrgidList]);

  const id = (messageId === MarkDownEnum.PriceMatch && items?.isRemovePriceMatch) ? 
                    MarkDownEnum.PriceMatchNoData : 
                    (messageId === MarkDownEnum.PrivacyPolicy && isExclude) ? 
                          MarkDownEnum.PrivacyPolicyExclusive : 
                          messageId;

  let message = intl.formatMessage({ id });

  message = message.replace('{phone}', (phone || isMLM) ? faqMarkDownContent(phone as string, mainBackgroundColor as string) : '')
  message = message.replace('{styleobject}', !isEmpty(mainBackgroundColor) ? `style="background: ${mainBackgroundColor}"` : '')
  message = message.replace('{clubName}', organizationName);

  return (
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
      {message}
    </ReactMarkdown>
  );
}

